import axios from "axios";
import React, { useState, useEffect, useRef, useCallback } from "react";
import { Modal } from "react-responsive-modal";
import "react-responsive-modal/styles.css";
import { Tab, Tabs, TabList, TabPanel } from "react-tabs";
import { Toaster, toast } from "react-hot-toast";
import { AnalyticsService } from "../../utils/Analytics";
import {
  Title,
  SecondaryButton,
  Spinner,
  AnchorLink,
} from "../../components/atoms";
import ProductsList from "../../components/Templates/ProductsList/ProductsList";
import ProductActions from "../../components/Templates/ProductActions/ProductActions";
import { AddProductForm, EditProductForm } from "../../components/organisms";
import { apiGet, apiPost, apiDelete } from "../../utils/services";
import {
  GETALLPRODUCTS,
  GETCATEGORIESLIST,
  DELETEPRODUCT,
  DUPLICATEPRODUCT,
  UPLOAD_PRODUCTS,
  DOWNLOAD_CSV,
  DOWNLOAD_SAMPLE_CSV,
} from "../../api/apiConfig";
import { Stack, Tooltip } from "@mui/material";
import { useParams } from 'react-router-dom';
//import DisplayProducts from "./DisplayProduct";

const getQuantity = (variants = []) => {
  if (variants.length) {
    return variants.reduce((acc, variant) => {
      acc += variant.inventoryQuantity;

      return acc;
    }, 0);
  }
};

const getLowestAmount = (varients) => {
  return varients.reduce((min, current) =>
    current.price < min.price ? current : min
  );
};

const DisplaySpinner = () => {
  return (
    <div className="spinnerDiv">
      <Spinner color={"black"} loading={true} size={40} />
    </div>
  );
};

const DisplayProducts = ({ data, onOpenModal, handleProductRef, initiateProductRef }) => {
  if (data) {

    initiateProductRef();

    return data.map(
      ({
        title,
        description,
        images,
        videos,
        variants,
        metaField,
        options,
        productId,
        tag,
        isTryBeforeYouBuy,
        isExclusive,
        modelId,
        gradeId,
        productUrl,
        status,
        isTopDeal,
        isTopDealTcsFunded,
        traits
      }, index) => {
        const quantity = tag === "Services" ? "-" : getQuantity(variants);
        const lowestAmount = getLowestAmount(variants);
        
      
        return (
          <div key={productId} ref={(ref) => handleProductRef(index, ref)} tabIndex={0}>
          <ProductsList
            key={productId}
            productTitle={tag === "Services" ? "Service name" : "Product name"}
            productName={title}
            image={images.length > 0 ? images[0].src : undefined}
            quantity={quantity}
            value={variants.length > 0 && `£${lowestAmount.price.toFixed(2)}`}
            isImage={images.length > 0 ? true : false}
            isTopDeal={isTopDeal}
            isTopDealTcsFunded={isTopDealTcsFunded}
            onOpenModal={() =>
              onOpenModal({
                index,
                title,
                description,
                images,
                videos,
                metaFields: metaField,
                variants,
                options,
                productId,
                tag,
                isTryBeforeYouBuy,
                isExclusive,
                productUrl,
                modelId,
                gradeId,
                traits
              })
            }
            isActive={status == "active"}

          />
          </div>
        );
      }
    );
  } else {
    return null;
  }
}
function orderProducts(products, collects) {
  // Create a map to quickly access position by productId
  const positionMap = new Map(
    collects.map((collect) => [collect.product_id, collect.position])
  );

  // Sort the products array based on position
  products.sort((a, b) => {
    const positionA = positionMap.get(a.id);
    const positionB = positionMap.get(b.id);

    // If either position is undefined, move it to the end
    if (positionA === undefined) return 1;
    if (positionB === undefined) return -1;

    return positionA - positionB;
  });
}

const Dashboard = () => {
  const [showProduct, setShowProduct] = useState(false);
  const [addProduct, setAddProduct] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [showList, setShowList] = useState(true);
  const [data, setData] = useState();
  const [isLoadingOption, setIsLoadingOption] = useState(false);
  const [isLoadingDel, setIsLoadingDel] = useState(false);
  const element = useRef(null);
  let productListRef = useRef([]);

  


  const showEmpty = () => {
    setShowProduct(false);
    setAddProduct(false);
    setShowList(true);
    AnalyticsService.logEvent("CATEGORY_LIST_VIEW");
  };

  const [state, setState] = useState({
    description: "",
    productName: "",
    productPrice: "",
    quantity: "",
    options: [],
    images: [],
    videos: [],
    metaFields: [],
    productId: "",
    category: "",
    isTryBeforeYouBuy: false,
    isExclusive: false,
    productCategories: [],
    fields: {},
    weight: 0.0,
    weightUnit: "lb",
    variants: [],
    
  });

  const {
    description,
    productName,
    productPrice,
    quantity,
    options,
    images,
    videos,
    productId,
    category,
    isTryBeforeYouBuy,
    isExclusive,
    productCategories,
    weightUnit,
    metaFields,
    weight,
    variants,
    modelId,
    gradeId,
    
    
  } = state;

  const updateState = (data) => setState(() => ({ ...state, ...data }));
  const [open, setOpen] = useState(false);
  const [getproductId, setProductId] = useState("");
  const [getproductUrl, setProductUrl] = useState("");
  const [proTitle, setProTitle] = useState("");
  const [proDesc, setProDesc] = useState("");
  const [proImages, setProImages] = useState([]);
  const [proVideos, setProVideos] = useState([]);
  const [proMetaFields, setProMetaFields] = useState([]);
  const [proOptions, setProOptions] = useState([]);
  const [proVariants, setProVariants] = useState([]);
  const [proTag, setProTag] = useState("");
  const [proTry, setProTry] = useState("");
  const [proExclusive, setProExclusive] = useState("");
  const [isTopDeal, setIsTopDeal] = useState(false);
  const [proModelId, setProModelId] = useState(null);
  const [proGradeId, setProGradeId] = useState(null);
  const [collects, setCollects] = useState([]);
  const [trait, setTraits] = useState(null);

  const onOpenModal = ({
    index,
    title,
    description,
    images,
    videos,
    metaFields,
    variants,
    options,
    productId,
    tag,
    isTryBeforeYouBuy,
    isExclusive,
    productUrl,
    modelId,
    gradeId,
    isTopDeal,
    traits
  }) => {
   
    setOpen(true);
    setProductId(productId);
    setProductUrl(productUrl);
    setProTitle(title);
    setProDesc(description);
    setProImages(images);
    setProVideos(videos);
    setProMetaFields(metaFields);
    setProVariants(variants);
    setProOptions(options);
    setProTag(tag);
    setProTry(isTryBeforeYouBuy);
    setProExclusive(isExclusive);
    setProModelId(modelId);
    setProGradeId(gradeId);
    setIsTopDeal(isTopDeal);
    setTraits(traits);
    
    if (productListRef.current[index]) {
      productListRef.current[index].focus();
    }
  };
  const initiateProductRef = () =>{
    productListRef.current = [];
  }
  const handleProductRef = (index, ref) => {
    productListRef.current[index] = ref;

    console.log(productListRef);
  };
  
  const onCloseModal = () => {
    setOpen(false);
  };

  useEffect(() => {
    getProductCategories();
    getProducts();
    AnalyticsService.logEvent("PRODUCTS_LIST_VIEW");
    window.history.pushState(null, document.title, window.location.href);
    window.addEventListener("popstate", function (event) {
      window.history.pushState(null, document.title, window.location.href);
    });

    
  }, []);
  
  const scrollToForm = () => {
    if (window.pageYOffset > 300)
      window.scrollTo({ top: element.current.offsetTop, behavior: "smooth" });
  };

  const getProductCategories = async () => {
    setIsLoading(true);
    const res = await apiGet(GETCATEGORIESLIST);
    if (res) {
      const { data } = res;
      updateState({ productCategories: data });
    }
    setIsLoading(false);
  };

  const getProducts = useCallback(async () => {
    setIsLoading(true);
    const res = await apiPost(GETALLPRODUCTS, { vendor: "The Cricket Store" });
    
    if (res) {
      setData(res);
      //setCollects(res.collects)
    }
    setIsLoading(false);
  }, [setData, setIsLoading]);

  const ShowAddProduct = () => {
    setShowProduct(true);
    setAddProduct(true);
    setShowList(false);
    //Add_Product_View_log
    AnalyticsService.logEvent("ADD_PRODUCT_VIEW");
  };

  const ShowEditProduct = ({
    proTitle,
    proDesc,
    proImages,
    proVideos,
    proVariants,
    proMetaFields,
    proOptions,
    getproductId,
    proTag,
    proTry,
    proExclusive,
    proModelId,
    proGradeId,
    isTopDeal,
    trait
  }) => {

    console.log("---traits", trait);
    setShowList(false);
    onCloseModal();
    scrollToForm();
    let quantity, price, category, weight, weightUnit;

    
    if (proVariants.length > 0) {
      quantity = String(proVariants[0].inventoryQuantity);
      
      let prices = proVariants.map(variant => variant.price);
      price = String(Math.min(...prices));
      category = proTag;
      weight = proVariants.length > 0 ? proVariants[0].weight : 0.0;
      weightUnit = proVariants.length > 0 ? proVariants[0].weightUnit : "lb";
    }
    setShowProduct(true);
    setAddProduct(false);
    setIsTopDeal(isTopDeal);
    setTraits(trait);
    updateState({
      productName: proTitle,
      description: proDesc,
      productPrice: price,
      quantity,
      images: proImages,
      videos: proVideos,
      metaFields: proMetaFields,
      productId: getproductId,
      category: category,
      options: proOptions,
      isTryBeforeYouBuy: proTry,
      isExclusive: proExclusive,
      weight,
      weightUnit,
      variants: proVariants,
      modelId: proModelId,
      gradeId: proGradeId,
      
    });

    //Edit_Product_View_log
    AnalyticsService.logEvent("EDIT_PRODUCT_VIEW", {
      productName: proTitle,
      description: proDesc,
      productPrice: price,
      quantity,
      images: proImages,
      videos: proVideos,
      productId: getproductId,
      category: category,
      options: proOptions,
      isTryBeforeYouBuy: proTry,
      isExclusive,
      proExclusive,
      weight: weight,
      weightUnit: weightUnit,
    });
  };

  const hideMobile = () => {
    setShowProduct(false);
    setShowList(true);
  };
  const deleteProduct = async (productId) => {
    setIsLoadingDel(true);
    const res = await apiDelete(DELETEPRODUCT, { productId });
    if (res) {
      onCloseModal();
      //Product_deleted_event_log
      AnalyticsService.logEvent("PRODUCT_DELETED_SUCCESSFULLY", {
        ProductName: productName,
        ProductId: getproductId,
      });
      await getProducts();
    }
    setIsLoadingDel(false);
  };

  const duplicateProduct = async (getproductId) => {
    setIsLoadingOption(true);
    const res = await apiPost(DUPLICATEPRODUCT, { productId: getproductId });
    if (res) {
      onCloseModal();
      //Product_duplicated_event_log
      AnalyticsService.logEvent("PRODUCT_DUPLICATED_SUCCESSFULLY", {
        ProductName: productName,
        ProductId: getproductId,
      });
      await getProducts();
    }
    setIsLoadingOption(false);
  };

  const DisplayBar = ({ title }) => {
    const videoInputRef = useRef();
    const [isDownloading, setIsDownloading] = useState(false);
    const [isUploading, setIsUploading] = useState(false);
    return (
      <>
        <Toaster
          toastOptions={{
            style: {
              maxWidth: 500,
            },
          }}
        />
        <Title text={"Products"} className="pTitle" />
        <div className="actionsTab">
          <Title text={title} className="pSubTitle" />
          <Stack direction={"row"} spacing={1}>
            <SecondaryButton
              text={
                !isLoading && (!data || data.length <= 0)
                  ? "DOWNLOAD SAMPLE FILE"
                  : "DOWNLOAD PRODUCTS"
              }
              icon
              isLoading={isDownloading}
              className="blackSecBtn"
              color={"#fff"}
              type={3}
              onClick={async () => {
                let userData = localStorage.getItem("access_token");
                const url =
                  !isLoading && (!data || data.length <= 0)
                    ? DOWNLOAD_SAMPLE_CSV
                    : DOWNLOAD_CSV;
                setIsDownloading(true);
                axios({
                  url, //your url
                  method: "GET",
                  responseType: "blob", // important
                  headers: {
                    authorization: `Bearer ${userData}`,
                  },
                })
                  .then((response) => {
                    setIsDownloading(false);
                    // create file link in browser's memory
                    const href = URL.createObjectURL(response.data);

                    // create "a" HTML element with href to file & click
                    const link = document.createElement("a");
                    link.href = href;
                    link.setAttribute("download", "file.csv"); //or any other extension
                    document.body.appendChild(link);
                    link.click();

                    // clean up "a" element & remove ObjectURL
                    document.body.removeChild(link);
                    URL.revokeObjectURL(href);
                  })
                  .catch((e) => {
                    setIsDownloading(false);
                  });
              }}
            />

            <SecondaryButton
              text={"UPLOAD PRODUCTS"}
              icon
              className="blackSecBtn"
              isLoading={isUploading}
              color={"#fff"}
              type={2}
              onClick={() => {
                videoInputRef.current.click();
              }}
            />
            <SecondaryButton
              text={"ADD PRODUCT"}
              icon
              onClick={ShowAddProduct}
              disabled={!data}
              className="greenSecBtn"
              color={"#fff"}
            />
          </Stack>
          <input
            ref={videoInputRef}
            type="file"
            accept=".csv"
            onChange={async (e) => {
              if (!e.target.files) return;
              const fileList = e.target.files;
              const formData = new FormData();
              formData.append("files", fileList[0]);
              try {
                setIsUploading(true);
                const response = await apiPost(UPLOAD_PRODUCTS, formData, {
                  "Content-Type": "multipart/form-data",
                });
                toast.success("Products Are Uploaded Successfully");
                setIsUploading(false);
                videoInputRef.current.value = null;
                getProducts();
                window.location.reload();
              } catch (error) {
                videoInputRef.current.value = null;
                setIsUploading(false);
                toast.error(error.message);
              }
            }}
            style={{ display: "none" }}
          />
        </div>
      </>
    );
  };

  const displayAddEditSection = () => {
    if (!showProduct)
      return (
        <div className="productsEditCls">
          <ProductActions />
        </div>
      );

    return addProduct ? (
      <div className="productsEditLayer">
        <div className="productsAE">
          <AddProductForm
            onCancelClick={hideMobile}
            setShowProduct={setShowProduct}
            getProducts={getProducts}
            productCategories={productCategories}
            setShowList={setShowList}
          />
        </div>
      </div>
    ) : (
      <div className="productsEditLayer">
        <div className="productsAE">
          <EditProductForm
            variants={variants}
            productCategories={productCategories}
            productCategory={category}
            onCancelClick={hideMobile}
            title={productName}
            value={productPrice}
            productDescription={description}
            productQuantity={quantity}
            productOptions={options}
            productImages={images}
            productVideos={videos}
            productMetaFields={metaFields}
            id={productId}
            setShowProduct={setShowProduct}
            getProducts={getProducts}
            setShowList={setShowList}
            tryBeforeYouBuy={isTryBeforeYouBuy}
            isExclusive={isExclusive}
            weightVal={weight}
            weightUnitVal={weightUnit}
            modelId={modelId}
            gradeId={gradeId}
            isTopDeal={isTopDeal}
            Traits={trait}
          />
        </div>
      </div>
    );
  };

  const MenuOption = ({
    onClick,
    text,
    className = "menu-option-item",
    IsSpinner,
    IsSpinnerDel,
  }) => {
    return (
      <div>
        <div onClick={onClick} className={className}>
          <span>{text}</span>
          {IsSpinner && (
            <div className="spinnerDivOption">
              <Spinner color={"black"} loading={isLoadingOption} size={20} />
            </div>
          )}
          {IsSpinnerDel && (
            <div className="spinnerDivDel">
              <Spinner color={"black"} loading={isLoadingDel} size={20} />
            </div>
          )}
        </div>
      </div>
    );
  };

  return (
    <>
      <div className="tabPanelCls">
        <Tabs defaultIndex={0}>
          <div className="fixed2">
            <TabList>
              <Tab onClick={showEmpty} key={0}>
                ALL PRODUCTS
              </Tab>
              {productCategories.map((category) => {
                return (
                  <Tab onClick={showEmpty} key={category.id}>
                    {category.name}
                  </Tab>
                );
              })}
            </TabList>
          </div>
          <TabPanel key={0} style={{ marginTop: "30px" }}>
            <div ref={element} className="productsPanel">
              <div
                className={showList ? "productsCls" : "productsCls displayNone"}
              >
                <DisplayBar title={"All Products"} />
                <div className="responsiveSpacing">
                  {isLoading ? (
                    <DisplaySpinner />
                  ) : (
                    <DisplayProducts
                    data={data} onOpenModal={onOpenModal} handleProductRef={handleProductRef} initiateProductRef={initiateProductRef}/>
                  )}
                </div>
              </div>
              {displayAddEditSection()}
            </div>
          </TabPanel>
          {productCategories.map((category) => {
            const productCategory = productCategories.find(
              (m) => m.id === category.id
            );
            return (
              <TabPanel key={category.id}>
                <div ref={element} className="productsPanel">
                  <div
                    className={
                      showList ? "productsCls" : "productsCls displayNone"
                    }
                  >
                    <DisplayBar title={category.name} />
                    <div className="responsiveSpacing">
                      {isLoading  ? 
                        <DisplaySpinner />
                        :<DisplayProducts data={data ? data?.filter((d) => d.tag === productCategory.name) : []} onOpenModal={onOpenModal} handleProductRef={handleProductRef} initiateProductRef={initiateProductRef}/>} 
                    </div>
                  </div>
                  {displayAddEditSection()}
                </div>
              </TabPanel>
            );
          })}
        </Tabs>
        <div className="click float">
          <a href="mailto:support@thecricketstore.uk">
            <Tooltip
              componentsProps={{
                tooltip: {
                  sx: {
                    bgcolor: "#E3031F",
                    fontSize: ".85rem",
                    "& .MuiTooltip-arrow": {
                      color: "#E3031F",
                    },
                  },
                },
              }}
              title={
                <React.Fragment>
                  <h3>Hi!, how can i help you</h3>
                </React.Fragment>
              }
              placement="left-start"
              arrow
            >
              <div>
                <img
                  src={require("../../assets/images/help.jpg")}
                  width={"30px"}
                />
              </div>
            </Tooltip>
          </a>
        </div>
      </div>
      <Modal
        open={open}
        showCloseIcon={false}
        center
        closeOnOverlayClick
        onClose={onCloseModal}
      >
        <AnchorLink text={"Preview"} url={getproductUrl} />
        <MenuOption
          text={"Edit"}
          onClick={() =>
            ShowEditProduct({
              proTitle,
              proDesc,
              proImages,
              proVideos,
              proMetaFields,
              proVariants,
              proOptions,
              getproductId,
              proTag,
              proTry,
              proExclusive,
              proModelId,
              proGradeId,
              isTopDeal,
              trait
            })
          }
        />
        <MenuOption
          text={"Duplicate"}
          onClick={() => duplicateProduct(getproductId)}
          IsSpinner
        />
        <MenuOption
          text={"Delete"}
          onClick={() => deleteProduct(getproductId)}
          className={"menu-item-del dark"}
          IsSpinnerDel
        />
        <MenuOption text={"Cancel"} onClick={onCloseModal} />
      </Modal>
    </>
  );
};

export default Dashboard;
